import  serviceClient from "./serviceClient";
import user from "./user";

const defaultTinyMceOptions = {
  // process|form|report detail
  suffix: '.min',
  branding: false,
  promotion: false,
  contextmenu: false,
  convert_unsafe_embeds: true,
  height: 200,
  min_height: 100,
  inline: false,
  menubar: false,
  selector: 'textarea#full-featured-non-premium',
  plugins: 'advlist autolink lists link charmap searchreplace wordcount insertdatetime nonbreaking table emoticons',
  toolbar: 'undo redo styles | fontfamily fontsizeinput | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | link |  numlist bullist | forecolor backcolor removeformat',

}


const dialogTinyMceOptions = Object.assign({}, defaultTinyMceOptions, {
  // display settings, process / tasks / edit detail
  // same as settings as SystemMessagesDialog.vue
  contextmenu: true,
  convert_unsafe_embeds: true,
  height: 400,
  toolbar: [
    'undo redo styles | fontfamily fontsizeinput | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify',
    'bullist numlist outdent indent | link | forecolor backcolor | charmap emoticons | Table',
  ]
})

const newDefaultTinyMceOptions = {
  // process|form|report detail
  suffix: '.min',
  branding: false,
  promotion: false,
  contextmenu: false,
  height: 200,
  min_height: 100,
  inline: false,
  menubar: false,
  convert_unsafe_embeds: true,
  selector: 'textarea#full-featured-non-premium',
  plugins: 'advlist autolink lists link charmap searchreplace wordcount insertdatetime nonbreaking table emoticons',
  toolbar: 'undo redo styles | fontfamily fontsizeinput | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | link |  numlist bullist | forecolor backcolor removeformat',
  convert_urls : false,
  images_reuse_filename: true,
  images_upload_handler: (blobInfo, progress) =>
    new Promise((resolve, reject) => {
      const filesClient = serviceClient.getClient("files");

      // Get the current user (you can pass a token if needed)
      user.get()
        .then((currentUser) => {
          // Proceed with file upload after getting the user information
          filesClient.then((filesClient) => {
            const file = new File([blobInfo.blob()], blobInfo.filename());
            filesClient.apis.files
              .uploadFile(
                { parentFolder: "temp", path: "/" },
                { requestBody: [file] }
              )
              .then((response) => {
                if (response.status === 200) {
                  const sid = response.obj[0].sid;
                  const loc = `/api/files/${sid}/download?contextType=temp&contextSid=${currentUser.SID}&embedded=true`;
                  resolve(loc);
                  return;
                } else {
                  reject("Upload failed");
                }
              })
              .catch((error) => {
                reject("Error during file upload: " + error);
              });
          });
        })
        .catch((error) => {
          reject("Error retrieving current user: " + error);
        });
    }),
};

const newDialogTinyMceOptions = Object.assign({}, newDefaultTinyMceOptions, {
  // display settings, process / tasks / edit detail
  // same as settings as SystemMessagesDialog.vue
  contextmenu: true,
  convert_unsafe_embeds: true,
  sandbox_iframes: true,
  height: 400,
  toolbar: [
    'undo redo | styles | fontfamily fontsizeinput | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify',
    'bullist numlist outdent indent | link | forecolor backcolor | charmap emoticons | Table',
  ]
})

export default { defaultTinyMceOptions, newDefaultTinyMceOptions, dialogTinyMceOptions, newDialogTinyMceOptions };
